import { useInfiniteQuery } from '@tanstack/react-query';
import { ClientQueryResponse } from '@cko/dashboard-shared';
import useClientsFetcher from './useClientsFetcher';

export const useClientsQuery = (clientsFetcherUrl: string, query: string, limit: number) => {
  const clientsFetcher = useClientsFetcher(clientsFetcherUrl);
  const querykey = ['fetchClients', limit, query];
  const results = useInfiniteQuery<ClientQueryResponse>(querykey, clientsFetcher, {
    getNextPageParam: (lastPage, pages) => {
      // this checks whether we should fetch more when we try to do so
      // the fetchNextPage function will not be called if this returns undefined

      const numPages = pages.length;
      const numClientsToCurrentPage = numPages * limit;
      const totalClients = lastPage.total_count;

      if (totalClients - numClientsToCurrentPage <= 0) {
        return undefined;
      }
      // this value is passed to fetchNextPage when it's called through
      // the optional pageParam arg, and is assigned to the skip value
      return numClientsToCurrentPage;
    },
    refetchOnWindowFocus: false,
  });

  const clients = results.isSuccess ? results?.data.pages.flatMap((page) => page.data).flat() : [];

  return { clients, ...results };
};
